import { Badge } from '@/components/ui/badge';
import { testIds } from '@/lib/test-ids';
import type { QuizQuestion } from '@/lib/quiz-parser';

interface QuizPreviewModeProps {
  questions: QuizQuestion[];
}

export function QuizPreviewMode({ questions }: QuizPreviewModeProps) {
  if (questions.length === 0) {
    return (
      <p className="text-sm text-muted-foreground p-6">No questions found in quiz fence.</p>
    );
  }

  return (
    <div className="p-5 space-y-6" data-testid={testIds.quizDocumentRenderer.previewMode}>
      {questions.map((q, i) => (
        <div key={q.id} className="border border-border rounded-md p-4 space-y-2">
          <div className="flex items-center gap-2 flex-wrap">
            <span className="text-xs font-medium text-muted-foreground">Q{i + 1}</span>
            <Badge variant="outline" className="text-xs">
              {q.domain.replace(/_/g, ' ')}
            </Badge>
            {q.difficulty && (
              <Badge variant="secondary" className="text-xs">
                {q.difficulty}
              </Badge>
            )}
          </div>
          <p className="text-sm font-medium">{q.stem}</p>
          <ul className="text-sm space-y-1 pl-2">
            {Object.entries(q.options).map(([key, label]) => (
              <li
                key={key}
                className={key === q.answer ? 'text-green-600 font-medium' : 'text-muted-foreground'}
              >
                <span className="font-mono mr-1">{key.toUpperCase()}.</span>
                {label}
                {key === q.answer ? ' (answer)' : ''}
              </li>
            ))}
          </ul>
          {q.explanation && (
            <p className="text-xs text-muted-foreground border-t border-border pt-2 mt-2">
              {q.explanation}
            </p>
          )}
        </div>
      ))}
    </div>
  );
}
